module.exports = "https://static.wmbcdn.com/uniweb/images/a13a16e7a2bad18e446a8013949c5d85.svg";